<template>
    <div class="ml-auto mr-auto" style="max-width: 400px;">
        <form
            id="wfhForgotPasswordForm"
            @submit="submitForm"
        >
            <div class="mt-30">
                <label
                    for="email"
                    class="wfh-form-label"
                    :class="{'text-danger': emailError}"
                >
                    Email Address
                </label>
                <input
                    class="form-control wfh-input-box"
                    :class="{'is-invalid': emailError}"
                    style="background-image: none !important;"
                    type="email"
                    id="email"
                    v-model="email"/>
                <span v-if="emailError" v-text="emailError" class="wfh-err-label"></span>
            </div>

            <div class="text-center">
                <button
                    type="submit"
                    :disabled="!formCompleted || loading"
                    class="btn wfh-btn-primary position-relative"
                    style="margin-top: 30px;"
                >
                    <span
                        class="spinner-border position-absolute"
                        role="status"
                        style="left: 16px;top: 10px;"
                        v-show="loading"
                    >
                        <span class="sr-only">Loading...</span>
                    </span>
                    Send password reset link
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                emailError: '',
                loading: false
            }
        },

        computed: {
            formCompleted() {
                return this.email;
            }
        },

        methods: {
            async submitForm(e) {
                this.loading = true;
                e.preventDefault();
                this.validateEmail();

                if (this.validateEmail()) {
                    try {
                        await axios.post('/password/email', {
                            email: this.email
                        });

                        location.href = '/login';
                    } catch (e) {
                        this.emailError = 'Your email does not match our record';
                    }
                }

                this.loading = false;
            },

            validateEmail() {
                const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (!emailReg.test(this.email)) {
                    this.emailError = 'Invalid email address please try again';
                    return false;
                }

                return true;
            },

            resetValidation() {
                this.emailError = null;
            }
        }
    }
</script>

<style scoped>
    .mt-30 {
        margin-top: 30px;
    }
</style>
